module.exports = __webpack_public_path__ + "img/reject.dafa654f.png";